class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop-only hover-to-open, with a short close delay so the cursor can
    // travel from the parent menu item into the dropdown without it closing.
    // Gated on (hover: hover) and (pointer: fine) in addition to the width
    // check so touch/tablet devices never get hover-only navigation, even at
    // desktop widths. Click-to-toggle (native <details>/<summary> behavior)
    // and keyboard Enter/Space activation are left completely untouched.
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    this.hoverCloseTimeout = null;
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;
    window.clearTimeout(this.hoverCloseTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;
    window.clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = window.setTimeout(() => {
      this.close();
    }, 250);
  }

  onFocusIn(event) {
    if (!this.hoverMediaQuery.matches) return;
    if (event.target === this.summary) {
      window.clearTimeout(this.hoverCloseTimeout);
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
